var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyePatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 140.68c-137.69 0.10938-268.07 61.98-355.23 168.58l796.52 163.99c-56.516-196.84-236.51-332.48-441.29-332.57zm-379.49 200.61c-52 76.258-79.82 166.41-79.832 258.71 0 253.68 205.65 459.32 459.32 459.32s459.32-205.65 459.32-459.32c-0.13281-29.492-3.1016-58.902-8.875-87.824l-114.4-23.555c-6.7734 61.281-46.664 114.59-104.55 137.97-62.535 25.254-134.24 10.812-182.12-36.684-44.664-44.309-60.715-109.58-42.578-169.07l-385.62-79.398c-0.22266-0.046875-0.44531-0.097656-0.66406-0.14844zm190.76 105.29c41.203 0 74.605 33.402 74.602 74.605 0 41.199-33.402 74.602-74.602 74.602-41.203 0.003906-74.605-33.398-74.605-74.602-0.003906-41.203 33.402-74.609 74.605-74.605zm13.539 377.68h350.39c10.145-0.18359 18.469 7.9922 18.469 18.141s-8.3242 18.324-18.469 18.141h-350.39c-10.145 0.18359-18.469-7.9922-18.469-18.141s8.3242-18.324 18.469-18.141z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePatch);
export default __webpack_public_path__ + "static/media/eye-patch.b665f0154fcea2c37363cf266e6daeb3.svg";
export { ForwardRef as ReactComponent };